import { useNavigate } from "react-router-dom";
import * as React from "react";
import { useRef } from "react";
import { UserTable } from "../../component/UserTable";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Button, Container, Stack } from "@mui/material";
import { useDispatch } from "react-redux";
import {
  isFromEdit,
  isFromEditData,
} from "../../redux/Reducers/AdminMGAUserReducer";
import { strings, paths } from "../../utils/constants";

export default function UserPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const addHandler = () => {
    dispatch(isFromEdit(false));
    dispatch(isFromEditData({}));
    navigate(paths.adminRoutes.ADD_EDIT_USER);
  };
  return (
    <>
      <Container style={{ width: "80%", marginRight: "4%" }}>
        <Stack direction="column" alignItems="end">
          <Stack direction="row" gap={1}>
            <Button
              variant="contained"
              sx={{ color: "#184437" }}
              className="uabutton"
              startIcon={<FileDownloadIcon />}
              onClick={() => tableRef.current?.handleExport()}
            >
              {strings.words.EXPORT}
            </Button>
            <Button
              variant="contained"
              sx={{ color: "#184437" }}
              className="uabutton"
              startIcon={<AddIcon />}
              onClick={addHandler}
            >
              {strings.general.ADD_NEW_USER}
            </Button>
          </Stack>
        </Stack>
      </Container>
      <UserTable ref={tableRef} />
    </>
  );
}
